import { render, staticRenderFns } from "./OfferListTableDetailsPntsPts.vue?vue&type=template&id=6ce4f3d4&scoped=true"
import script from "./OfferListTableDetailsPntsPts.vue?vue&type=script&lang=js"
export * from "./OfferListTableDetailsPntsPts.vue?vue&type=script&lang=js"
import style0 from "./OfferListTableDetailsPntsPts.vue?vue&type=style&index=0&id=6ce4f3d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4f3d4",
  null
  
)

export default component.exports